import React from 'react';
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router';
import { HelmetProvider } from 'react-helmet-async';
import { router } from './src/routes.config';
import './style.css';
import './styles/swiper_overrides.sass';
import "@fortawesome/fontawesome-free/css/all.min.css";
import './src/i18n';

createRoot(document.getElementById('root')!).render(
    <HelmetProvider>
        <RouterProvider router={router} />
    </HelmetProvider>
);